<template>
    <v-carousel
        v-model="model"
        class="hero-carousel"
        :height="cssHeightValue"
        :cycle="!paused"
        :interval="interval"
        hide-delimiter-background
    >
        <template #prev="{ props }">
            <SliderButton
                type="prev"
                alt="Previous Slide"
                v-bind="props"
                @mouseenter="togglePause(true)"
                @mouseleave="togglePause(false)"
            ></SliderButton>
        </template>
        <template #next="{ props }">
          <SliderButton
                type="next"
                alt="Next Slide"
                v-bind="props"
                @mouseenter="togglePause(true)"
                @mouseleave="togglePause(false)"
            ></SliderButton>
        </template>

        <!-- Mark 3 Family -->
        <v-carousel-item>
            <NuxtLink
                class="d-block video-panel video-panel-mark-3-family position-relative fill-width fill-height"
                to="/mens-lacrosse/mark-3-family"
            >
                <video
                    class="fill-width fill-height"
                    playsinline
                    autoplay
                    muted
                    loop
                >
                    <source
                        :src="`${cdnBasePathMain}/static/common/videos/hero/mark-3-family/mark-3-family-sm-2.mp4`"
                        type="video/mp4"
                        media="(max-width:959px)"
                    />
                    <source
                        :src="`${cdnBasePathMain}/static/common/videos/hero/mark-3-family/mark-3-family-lg.mp4`"
                        type="video/mp4"
                    />

                    <track kind="captions">
                </video>
                <div
                    class="video-panel-content position-absolute pa-6 rounded-lg text-center d-flex flex-column align-center justify-center"
                >
                    <v-row
                        class="w-100 h-100 pa-0 ma-0"
                        dense
                    >
                        <v-col
                            v-if="!isMobile"
                            class="pa-0 ma-0"
                            cols="12"
                            md="6"
                        ></v-col>
                        <v-col
                            cols="12"
                            md="6"
                            class="d-flex flex-column align-center justify-center order-1 order-md-2 pa-0 ma-0 position-relative panel-col-info"
                        >
                            <h4
                                class="text-h4 text-md-h2 text-sm-h4 font-weight-bold text-uppercase px-2 mb-6 text-outline"
                            >

                                THE MARK 3 FAMILY
                            </h4>
                            <h5
                                class="text-md-h5 px-2 mb-6 text-outline font-weight-regular"
                                style="--text-outline-opacity: 0.08;"
                            >
                                Engineered with our ultra-stiff plastic.<br />
                                Designed for every position.
                            </h5>
                            <div>
                                <div
                                    class="secondary ma-2 bg-secondary btn-universal btn-universal-sim v-btn v-theme--light v-btn--density-default rounded-md v-btn--size-default v-btn--variant-flat"
                                    :class="{ 'v-btn--size-large': !isMobile }"
                                >
                                    Shop Now
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </NuxtLink>
        </v-carousel-item>

        <!-- The Kavanaghs (video) -->
        <v-carousel-item>
            <NuxtLink
                class="d-block video-panel video-panel-the-kavanaghs position-relative fill-width fill-height"
                to="/team-stringking/mens-lacrosse/pro-athletes"
            >
                <video
                    class="object-fit-cover fill-width fill-height"
                    playsinline
                    autoplay
                    muted
                    loop
                >
                    <source
                        :src="`${cdnBasePathMain}/static/common/videos/hero/the-kavanaghs/banner-kavanaghs-sm.mp4`"
                        type="video/mp4"
                        media="(max-width:959px)"
                    />
                    <source
                        :src="`${cdnBasePathMain}/static/common/videos/hero/the-kavanaghs/banner-kavanaghs-lg.mp4`"
                        type="video/mp4"
                    />
                    <track kind="captions">
                </video>
                <div
                    class="video-panel-content position-absolute pa-6 rounded-lg text-center d-flex flex-column align-center justify-center"
                >
                    <h4
                        class="text-md-h2 text-sm-h3 text-h4 font-weight-bold px-2 mb-6 no-invert text-outline"
                    >
                        THE BEST TRUST STRINGKING
                    </h4>
                    <h5
                        class="text-md-h5 text-h6 px-2 mb-6 no-invert text-outline line-height-1"
                        style="--text-outline-opacity: 0.08;"
                    >
                        Meet some of the best players in the world who trust StringKing with their stick.
                    </h5>
                    <div
                        class="ma-2 bg-white btn-universal btn-universal-sim v-btn v-theme--light v-btn--density-default rounded-md v-btn--size-default v-btn--variant-flat"
                        :class="{ 'v-btn--size-large': !isMobile }"
                    >
                        Meet our Pros
                    </div>
                </div>
            </NuxtLink>
        </v-carousel-item>

        <!-- Flyer 1 -->
        <v-carousel-item>
            <NuxtLink
                class="image-panel-flyer-1 d-block position-relative fill-width fill-height no-underline-link"
                to="/mens-lacrosse/gloves/flyer-1"
            >
                <v-row
                    class="w-100 h-100"
                    dense
                >
                    <v-col
                        cols="12"
                        md="6"
                        class="d-flex flex-column align-center align-md-end justify-start justify-md-center order-2 order-md-1 pa-0 panel-col-main"
                    >
                        <div
                            class="pa-6 rounded-lg text-center fit-content"
                        >
                            <img
                                class="img-main"
                                :src="`${cdnBasePathMain}/static/common/images/carousel-home/flyer-1/flyer1-main-1.webp`"
                                alt="Flyer 1 Lacrosse Glove"
                            />
                        </div>
                    </v-col>
                    <v-col
                        cols="12"
                        md="6"
                        class="d-flex flex-column align-center align-md-start justify-center order-1 order-md-2 pa-0 panel-col-info"
                    >
                        <div
                            class="ml-md-16 pa-6 rounded-lg text-center fit-content"
                        >
                            <img
                                class="img-logo mx-auto mb-2 mb-md-12"
                                :src="`${cdnBasePathMain}/static/common/images/carousel-home/flyer-1/logo-flyer1-blk.svg`"
                                alt="Flyer 1 Lacrosse Glove Logo"
                            />
                            <h5
                                class="img-caption font-weight-medium px-2 mb-2 mb-md-8 no-invert text-outline"
                            >
                                The most flexible glove in lacrosse.
                            </h5>
                            <div
                                class="secondary ma-2 bg-secondary btn-universal btn-universal-sim v-btn v-theme--light v-btn--density-default rounded-md v-btn--size-default v-btn--variant-flat"
                                :class="{ 'v-btn--size-large': !isMobile }"
                            >
                                Shop Now
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </NuxtLink>
        </v-carousel-item>

        <!-- Type 5 Mesh -->
        <v-carousel-item>
            <NuxtLink
                class="d-block video-panel video-panel-type-5 position-relative fill-width fill-height"
                to="/mens-lacrosse/mesh/mens-type-5?sku=type-5-type-5x-custom-string-kit-white"
            >
                <video
                    class="object-fit-cover fill-width fill-height"
                    playsinline
                    autoplay
                    muted
                    loop
                >
                    <source
                        :src="`${cdnBasePathMain}/static/common/videos/hero/MeshBannerVideo-1600x640.mp4`"
                        type="video/mp4"
                    >
                    <track kind="captions">
                </video>
                <div
                    class="video-panel-content position-absolute pa-6 rounded-lg text-center"
                >
                    <h4
                        class="text-md-h1 text-h2 font-weight-bold text-uppercase px-2 mb-6 no-invert text-outline"
                    >
                        TYPE 5 MESH
                    </h4>
                    <h5
                        class="text-md-h4 text-h5 font-weight-bold px-2 mb-6 no-invert text-outline"
                    >
                        CONSISTENCY IS KING
                    </h5>
                    <div
                        class="secondary ma-2 bg-secondary btn-universal btn-universal-sim v-btn v-theme--light v-btn--density-default rounded-md v-btn--size-default v-btn--variant-flat"
                        :class="{ 'v-btn--size-large': !isMobile }"
                    >
                        Shop Now
                    </div>
                </div>
            </NuxtLink>
        </v-carousel-item>

        <!-- Metal 3 Pro -->
        <v-carousel-item>
            <NuxtLink
                class="d-block video-panel video-panel-metal-3-pro position-relative fill-width fill-height"
                to="/mens-lacrosse/shafts/mens-metal-3-pro-attack?sku=mens-metal-3-pro-attack-175-grams-silver"
            >
                <video
                    class="object-fit-cover fill-width fill-height"
                    playsinline
                    autoplay
                    muted
                    loop
                >
                    <source
                        :src="`${cdnBasePathMain}/static/common/videos/hero/shaft-V2.mp4`"
                        type="video/mp4"
                    >
                    <track kind="captions">
                </video>
                <div
                    class="video-panel-content position-absolute pa-6 rounded-lg text-center"
                >
                    <h4
                        class="text-md-h1 text-h2 font-weight-bold text-uppercase px-2 mb-6 no-invert text-outline"
                    >
                        METAL 3 PRO SHAFTS
                    </h4>
                    <div
                        class="secondary ma-2 bg-secondary btn-universal btn-universal-sim v-btn v-theme--light v-btn--density-default rounded-md v-btn--size-default v-btn--variant-flat"
                        :class="{ 'v-btn--size-large': !isMobile }"
                    >
                        Shop Now
                    </div>
                </div>
            </NuxtLink>
        </v-carousel-item>

        <!-- Apparel -->
        <v-carousel-item>
            <div
                class="d-block video-panel video-panel-apparel position-relative fill-width fill-height"
            >
                <video
                    class="object-fit-cover fill-width fill-height"
                    playsinline
                    muted
                    loop
                    autoplay
                >
                    <source
                        :src="`${cdnBasePathMain}/static/common/videos/hero/apparel-banner-1.mp4`"
                        type="video/mp4"
                    >
                    <track kind="captions">
                </video>
                <div
                    class="video-panel-content position-absolute pa-6 rounded-lg text-center d-flex flex-column align-center justify-center"
                >
                    <div
                        class="mb-8"
                    >
                        <v-img
                            class="img-logo"
                            :src="`${cdnBasePathMain}/static/common/images/carousel-home/stringking-apparel-header-logo.svg`"
                            :width="isMobile ? '70vw' : '30rem'"
                            height="auto"
                            alt="StringKing Baseball"
                        ></v-img>
                    </div>
                    <h5
                        class="text-md-h4 text-h5 font-weight-bold px-2 mb-6 no-invert text-outline"
                    >
                        #1 IN CUSTOM FIT
                    </h5>
                    <div
                        class="d-flex flex-wrap gap-6 justify-center align-center"
                    >
                        <v-btn
                            color="secondary"
                            :size="isMobile ? 'default' : 'large'"
                            to="/search/mens-apparel"
                        >
                            Men's Apparel
                        </v-btn>
                        <v-btn
                            color="secondary"
                            :size="isMobile ? 'default' : 'large'"
                            to="/search/womens-apparel"
                        >
                            Women's Apparel
                        </v-btn>
                    </div>
                </div>
            </div>
        </v-carousel-item>

    </v-carousel>
</template>

<script lang="ts" setup>
    import SliderButton from '~/components/carousel/SliderButton/SliderButton.vue';
    import { useIsMobile } from '~/composables';
    import {
        useCdnResource
    } from 'x1-base/composables';

    defineProps({
        cssHeightValue: {
            type: String as PropType<string>,
            default: '100vh'
        }
    });

    const {
        isMobile
    } = useIsMobile();
    const {
        cdnBasePathMain
    } = useCdnResource();

    const model = ref<number>(0);

    const paused = ref<boolean>(false);

    const interval = ref<number>(10000);

    async function togglePause(val: boolean): Promise<void> {
        await nextTick();
        paused.value = val;
    }
</script>

<style lang="scss">
.hero-carousel {
    .image-panel,
    .video-panel {
        &-content {
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: fit-content;
            height: fit-content;

            h4, h5 {
                filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.15));

                &.no-invert {
                    filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.15));
                    color: #fff;
                }

                &.no-drop-shadow {
                    filter: none;
                }
            }

            .img-logo {
                filter: drop-shadow(0 8px 8px rgba(0, 0, 0, 0.2));
            }
        }
    }

    .slide-move-btn {
        opacity: 0.1;
        transition: opacity 0.4s ease;
    }
    &:hover {
        .slide-move-btn {
            opacity: 0.4;
            transition: opacity 0.4s ease;
        }
    }

    .video-panel-apparel {
        background: linear-gradient(170deg, rgba(145,157,170,1) 0%, rgba(53,64,64,1) 46%, rgba(118,139,159,1) 52%, rgba(159,176,190,1) 84%, rgba(145,157,170,1) 100%);
    }

    .video-panel-type-5 {
        background: linear-gradient(180deg, rgba(55,112,127,1) 0%, rgba(160,183,196,1) 30%);
    }

    .video-panel-metal-3-pro {
        background: linear-gradient(180deg, rgba(196,195,200,1) 0%, rgba(255,255,255,1) 40%, rgba(255,255,255,1) 80%, rgba(221,207,185,1) 100%);
    }

    .video-panel-bbcor {
        background: linear-gradient(180deg, rgba(121,147,187,1) 0%, rgba(122,140,179,1) 50%, rgba(126,121,157,1) 69%, rgba(206,204,195,1) 90%);
    }

    .v-window__left,
    .v-window__right {
        top: calc(50% - 49px);
    }

    .text-outline {
        -webkit-text-stroke: thin rgba(0, 0, 0, 0.1);
    }

}

// Flyer 1
.video-panel-flyer-1-launch,
.image-panel-flyer-1 {
    .img-caption {
        font-size: 140%;
        line-height: 1;
    }

    .img-logo {
        filter: drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.4)) !important;
    }
}

// Mark 3 Family
.video-panel-mark-3-family {
    .video-panel-content {
        width: 80%;
        height: 80%;
    }

    .panel-col-info {
        h5 {
            line-height: 1.8;
        }
    }
}


// Override ContentBlocks
.layout-desktop {
    .hero-carousel {
        h4.content-block-text-title {
            font-size: 3rem !important;
            font-weight: 400;
            line-height: 3.125rem;
            letter-spacing: normal !important;
        }
    }

    .video-panel-flyer-1-launch,
    .image-panel-flyer-1 {
        .img-main {
            width: 100%;
            height: auto;
            max-width: 50vh;
        }

        .img-logo {
            width: 100%;
            height: auto;
            max-width: 30vh;
        }
    }
}
.layout-mobile {
    .hero-carousel {
        .v-window__controls {
            display: none !important;
        }
    }


    // Flyer 1
    .image-panel-flyer-1 {
        .img-caption {
            font-size: 110%;
        }

        .img-main {
            width: 40vh;
            height: auto;
        }

        .img-logo {
            width: 24vw;
            height: auto;
        }
    }


    // Mark 3 Family
    .video-panel-mark-3-family {
        video {
            object-fit: cover;
        }

        .video-panel-content {
            width: 100%;
            height: 100%;
        }

        .panel-col-info {
            h5 {
                line-height: 1.4;
            }
        }
    }
}

</style>
